import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About`}</h2>
    <p><strong parentName="p">{`Application Security Engineer and Penetration Tester 🐱‍💻`}</strong></p>
    <p><strong parentName="p">{`Switching back to my preferred industry: Software Development 👨‍💻`}</strong></p>
    <p>{`Interested in developing the full stack, engineering the backend, architecting `}<em parentName="p">{`artistic`}</em>{` solutions, and solving worthwhile problems 🌌`}</p>
    <p>{`My `}<a href="https://www.linkedin.com/in/barasec" target="_blank">{`LinkedIn`}</a>{`, `}<a href="mailto:barasec@protonmail.com">{`Email`}</a>{`, `}<a href="https://github.com/barasec" target="_blank">{`GitHub`}</a>{`, and `}<a href="https://drive.google.com/file/d/1Rrg298IxXvQKcJKCFzhdwazRcqYdhJ0o/view?usp=sharing" target="_blank">{`CV`}</a>{` are available below 👇`}</p>
    <p>{`Chat me!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      